/** @jsxImportSource @emotion/react */
import React from 'react';
import { Form, InputNumber } from 'antd';
import commonStyles from '../../../../../styles/commonStyles';

/** Quantity fields. Lifecycle completion is handled by explicit disposition actions. */
const BasicFieldsSection: React.FC = () => (
  <>
    <Form.Item
      label="Количество растений"
      name="quantity"
      tooltip="Для групповых посадок (например, гортензии, спиреи) укажите количество растений. Для единичных посадок (сосны, ели) оставьте 1."
      rules={[
        { required: true, message: 'Укажите количество' },
        { type: 'number', min: 1, message: 'Количество должно быть больше 0' },
      ]}
      initialValue={1}
    >
      <InputNumber
        min={1}
        step={1}
        placeholder="Количество растений"
        css={commonStyles.fullWidth}
        addonAfter="шт"
      />
    </Form.Item>

  </>
);

export default BasicFieldsSection;
